export const expansionCopy = {
  "en-GB": {
    "settings.title.RESET": "Restart tracker",
    "settings.help.RESET": "The tracker disconnects while it restarts. Check that it reconnects before relying on tracking or alarms.",
    "settings.validation.RESET": "Review the restart before sending.",
    "settings.title.POWEROFF": "Power off tracker",
    "settings.help.POWEROFF": "Tracking and alarms stop when the tracker is off. Someone must be able to turn it on using its physical button.",
    "settings.validation.POWEROFF": "Review power off before sending.",
    "settings.title.FACTORY": "Factory reset",
    "settings.help.FACTORY": "Resets device settings. SOS numbers and mobile connection may be lost. Have the device and setup guide ready. Your Qtracker history is kept.",
    "settings.validation.FACTORY": "Review the reset before sending.",
    "settings.title.SPOF": "Power schedule",
    "settings.help.SPOF": "Uses the bracelet’s clock. It cannot track or raise alarms while off. Test automatic power on with the bracelet nearby before relying on a schedule.",
    "settings.validation.SPOF": "Enter HH:MM and select at least one weekday.",
    "settings.title.LSSET": "Fall sensitivity",
    "settings.help.LSSET": "Choose sensitivity from 1 to 6. 1 is most sensitive and 6 is least sensitive. Use the separate switch to turn fall detection on or off.",
    "settings.validation.LSSET": "Choose a level from 1 to 6.",
    "settings.title.WIFIFENCE": "Wi-Fi safety area",
    "settings.help.WIFIFENCE": "The area is recognised using three 2.4 GHz Wi-Fi networks. Enter their MAC addresses from the router settings. The area cannot be removed from the device in the app yet.",
    "settings.validation.WIFIFENCE": "Enter three different access point MAC addresses, for example 02:11:22:33:44:55.",
    "settings.title.MONITOR": "Request a call back",
    "settings.help.MONITOR": "Ask the device to call the number below. Normal call charges may apply.",
    "settings.validation.MONITOR": "Enter a telephone number with 6–15 digits and optional +.",
    "settings.monitorConsent": "Only start a call when the wearer and recipient know and agree to it.",
    "settings.callbackNumber": "Call this number",
    "settings.sensitivityLevel": "Level",
    "settings.macAddress": "Wi-Fi network {slot}: MAC address",
    "settings.power.on": "Power on",
    "settings.power.off": "Power off",
    "settings.recoveryRequired": "Make sure someone can reach the bracelet and restore it before continuing."
  },
  "da-DK": {
    "settings.title.RESET": "Genstart tracker",
    "settings.help.RESET": "Trackeren mister forbindelsen under genstart. Kontrollér, at den kommer online igen, før du regner med position og alarmer.",
    "settings.validation.RESET": "Gennemgå genstarten før afsendelse.",
    "settings.title.POWEROFF": "Sluk tracker",
    "settings.help.POWEROFF": "Position og alarmer stopper, mens trackeren er slukket. Nogen skal kunne tænde den igen med den fysiske knap.",
    "settings.validation.POWEROFF": "Gennemgå slukningen før afsendelse.",
    "settings.title.FACTORY": "Fabriksnulstilling",
    "settings.help.FACTORY": "Nulstiller enhedens indstillinger. SOS-numre og mobilforbindelse kan gå tabt. Hav enheden og opsætningsvejledningen klar. Din historik i Qtracker bevares.",
    "settings.validation.FACTORY": "Gennemgå nulstillingen før afsendelse.",
    "settings.title.SPOF": "Tænd/sluk efter tid",
    "settings.help.SPOF": "Bruger armbåndets ur. Der er ingen position eller alarmer, mens det er slukket. Afprøv automatisk tænding med armbåndet i nærheden, før du benytter en fast plan.",
    "settings.validation.SPOF": "Skriv TT:MM, og vælg mindst én ugedag.",
    "settings.title.LSSET": "Faldfølsomhed",
    "settings.help.LSSET": "Vælg følsomhed fra 1 til 6. 1 er mest følsom, og 6 er mindst følsom. Slå selve faldalarmen til eller fra med den særskilte kontakt.",
    "settings.validation.LSSET": "Vælg et niveau fra 1 til 6.",
    "settings.title.WIFIFENCE": "Tryghedszone med Wi-Fi",
    "settings.help.WIFIFENCE": "Området genkendes via tre 2,4 GHz-Wi-Fi-netværk. Indtast netværkenes MAC-adresser fra routerens indstillinger. Området kan ikke fjernes fra enheden i appen endnu.",
    "settings.validation.WIFIFENCE": "Skriv tre forskellige MAC-adresser, fx 02:11:22:33:44:55.",
    "settings.title.MONITOR": "Bed trackeren ringe tilbage",
    "settings.help.MONITOR": "Bed enheden ringe til nummeret nedenfor. Almindelig samtaletakst kan gælde.",
    "settings.validation.MONITOR": "Skriv et telefonnummer med 6–15 cifre og eventuelt +.",
    "settings.monitorConsent": "Start kun et opkald, når bæreren og modtageren ved det og er enige.",
    "settings.callbackNumber": "Ring til dette nummer",
    "settings.sensitivityLevel": "Niveau",
    "settings.macAddress": "Wi-Fi-netværk {slot}: MAC-adresse",
    "settings.power.on": "Tænd",
    "settings.power.off": "Sluk",
    "settings.recoveryRequired": "Sørg for, at nogen kan nå armbåndet og sætte det op igen, før du fortsætter."
  }
};
